<template>
  <div class="design-projects">
    <div class="col">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[0])" :src="designProjects[0].images[0]">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[1])" :src="designProjects[1].images[0]">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[5])" :src="designProjects[5].images[0]">
    </div>
    <div class="col">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[8])" :src="designProjects[8].images[0]">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[4])" :src="designProjects[4].images[0]">
    </div>
    <div class="col">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[6])" :src="designProjects[6].images[0]">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[7])" :src="designProjects[7].images[0]">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[3])" :src="designProjects[3].images[0]">
      <img class="design-project" v-on:click="$store.commit('viewProjectDetails', designProjects[2])" :src="designProjects[2].images[0]">
    </div>
  </div>
</template>

<script>
import { designProjects } from '../../../../data.js'
export default {
  data() {
    return {
      designProjects: designProjects
    }
  }
}
</script>

<style scoped>
.design-projects {
  display: flex;
}
.col {
  flex: 30%;
  margin-right: 25px;
}
.design-project {
  width: 100%;
  box-shadow: 1px 2px 8px 0px grey;
  background: white;
  margin-bottom: 25px;
  overflow: hidden;
  display: block;
  transition: .3s;
}
.design-project:hover {
  cursor: pointer;
}
.design-project:hover {
  transform: scale(1.05);
  transition: .3s;
}
/* ---------------------- MEDIA QUERY ---------------------- */
@media (max-width: 650px) {
  .design-projects {
    flex-direction: column;
    text-align: center;
  }
  .col {
    margin: 0;
  }
  .design-project {
    max-width: 90%;
    margin: 0 auto 30px auto;
  }
}
</style>
